function cryo_WindowAttachEvent(eventName, functionToCall) {
    if (window.attachEvent) {
        // IE

        // verifica se o evento est� no formato "onLoad"
        if (eventName.indexOf("on") == 0) {
            window.attachEvent(eventName, functionToCall);
        } else {
            window.attachEvent("on" + eventName, functionToCall);
        }
    } else {
        // Others - Mozilla

        // verifica se o evento foi escrito no formato "onLoad"
        if (eventName.indexOf("on") == 0) {
            // retira substring "on"
            var reg = new RegExp("^on", "gi");
            eventName = eventName.replace(reg, "");
        }
        window.addEventListener(eventName, functionToCall, true);
    }
}

function cryo_GetElementByXname(xname) {
    return cryo_GetElementByAttribute('xname', xname);
}

function cryo_GetElementByAttribute(attrib, str) {
    // find elements return array
    var findElements = function (tagn, attrib, str) {
        var msg = "";
        var A = document.getElementsByTagName(tagn);
        var O;
        O = [];
        var L = A.length;
        for (var i = 0; i < L; i++) {
            var tem = A[i];
            if (tem.getAttribute(attrib) && tem.getAttribute(attrib).toLowerCase() == str.toLowerCase()) {
                O.push(tem);
            }
        }
        if (O.length == 1) {
            return O.pop();
        } else if (O.length > 1) {
            return O;
        } else {
            return null;
        }
    };
    var obj = null;
    if (!obj) {
        obj = findElements('input', attrib, str);
    }
    if (!obj) {
        obj = findElements('select', attrib, str);
    }
    if (!obj) {
        obj = findElements('button', attrib, str);
    }
    if (!obj) {
        obj = findElements('textarea', attrib, str);
    }
    if (!obj) {
        obj = findElements('div', attrib, str);
    }
    if (!obj) {
        obj = findElements('ul', attrib, str);
    }
    if (!obj) {
        // Leonardo 15/07/2011
        obj = findElements('iframe', attrib, str);
    }
    return obj;
}

function cryo_GetElementByXnameRow(origin, str) {
    var tr = origin.parentNode;

    while (tr != null && tr.tagName.toLowerCase() != "tr") {
        tr = tr.parentNode;
    }
    if (!tr.tagName.toLowerCase() == "tr")
        return null;

    var inputs = tr.getElementsByTagName("input");
    for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].getAttribute("xname") && inputs[i].getAttribute("xname") == str) {
            return inputs[i];
        }
    }

    // inicio bloco adicionado em 28/09/2009 - Leonardo
    // permite buscar tamb�m objetos do tipo textarea
    var textarea = tr.getElementsByTagName("textarea");
    for (var i = 0; i < textarea.length; i++) {
        if (textarea[i].getAttribute("xname") && textarea[i].getAttribute("xname") == str) {
            return textarea[i];
        }
    }
    // fim bloco adicionado em 28/09/2009

    // 09/07/2009 - Leonardo - Adicionado suporte a busca por comboboxes
    var selects = tr.getElementsByTagName("select");
    for (var i = 0; i < selects.length; i++) {
        if (selects[i].getAttribute("xname") && selects[i].getAttribute("xname") == str) {
            return selects[i];
        }
    }
    return null;
}

// procura elementos de uma determinada TAG no documento HTML
// executa uma funcao em casa elemento encontrado
function cryo_Find(tagn, funct, o) {
    if (o == null) o = document;
    var A = o.getElementsByTagName(tagn);
    var L = A.length;
    for (var i = 0; i < L; i++) {
        var tem = A[i];
        funct(tem);
    }
}

function cryo_SetZeroValue(object) {
    if (object) {
        object.value = "";
    }
}

/*
    Possibilita mudan�a da valida��o de um campo da tarefa
*/
function cryo_ButtonValidationChanger(buttonId, newValidationFunction) {
    var button = getObj(buttonId);
    if (button) {
        function newValidation() {
            if (newValidationFunction()) {
                button.onclick = oldOnClick;
                if (window.attachEvent) {
                    // IE
                    button.fireEvent("onclick");
                    button.onclick = newValidation;
                } else {
                    // outros browsers

                    function fireEvent(sType, objeto) {
                        var e = document.createEvent("MouseEvent");
                        e.initEvent(sType, false, false);
                        objeto.dispatchEvent(e);
                    }
                    fireEvent("click", button);
                    button.onclick = newValidation;
                }
            }
        }

        var oldOnClick = button.onclick;
        button.onclick = newValidation;
    }
}

// retorna o codigo do campo buscando pelo seu XName
function cryo_GetCodFieldFromXName(xname) {
    var element = cryo_GetElementByAttribute('xname', xname);
    if (element && element.name && element.name != "") {
        if (element.name.toLowerCase().indexOf("inp") == 0) {
            return element.name.substring(3, element.name.length);
        } else {
            return element.name;
        }
    } else if (element && element.length > 1) {
        if (element[0].name.toLowerCase().indexOf("inp") == 0) {
            return element[0].name.substring(3, element[0].name.length);
        } else {
            return element[0].name;
        }
    }
}

function cryo_BlockEditingField(field) {
    field.readOnly = true;
    field.style.border = "0px";
}

function cryo_UnblockEditingField(field) {
    field.readOnly = "";
    field.style.border = "2px inset silver";
}

function cryo_ComboSelectItem(objCombo, itemValue, itemText) {
    for (i = 0; i < objCombo.options.length; i++) {
        if (itemValue) {
            if (objCombo.options[i].value == itemValue) {
                objCombo.options[i].selected = true;
            }
        } else {
            if (objCombo.options[i].text == itemText) {
                objCombo.options[i].selected = true;
            }
        }
    }
}

function cryo_GenericRejection(buttonId, strMessage, strButtonLabel) {
    var newBoxRejectionId = 'BoxRejection' + buttonId;
    var newBtnConfirmRejectionId = 'BtnConfirmRejection' + buttonId;

    // impedir a vinculacao dos eventos mais de uma vez
    if ($('#' + newBoxRejectionId).length > 0) {
        return;
    }

    // desvincular click do bot�o de rejeicao
    var oldOnClick = document.getElementById(buttonId).onclick;
    document.getElementById(buttonId).onclick = function () { };

    // clonar o box de rejeicao, trocar o id e adicionar nos controllers
    $("#BoxRejection").clone(true).prop('id', newBoxRejectionId).appendTo('#controllers');

    // mudar o id do botao de confirmacao da rejeicao
    $('#' + newBoxRejectionId + ' button#BtnConfirmRejection').prop('id', newBtnConfirmRejectionId);

    // remover o evento click do botao de confirmacao da rejeicao
    $("#" + newBtnConfirmRejectionId).unbind('click');

    // vincular nova funcao de validacao no botao de rejeicao
    $("#" + buttonId).click(newValidation);

    // alterar os textos conforme parametros
    $('#' + newBoxRejectionId + '>h3').text(strMessage);
    $('#' + newBoxRejectionId + '>button').text(strButtonLabel);

    function newValidation() {
        // esconde todos os boxes de comentarios
        $('.insertcoment').hide();

        // exibir o box de confirmacao da rejeicao
        $('#' + newBoxRejectionId).show();

        // remove o evento onclick do botao de confirmacao da rejeicao
        $('#' + newBtnConfirmRejectionId).prop('onclick', '');
        $('#' + newBtnConfirmRejectionId).unbind('click');

        // vincular nova funcao de validacao no botao de confirmacao da rejeicao
        $('#' + newBtnConfirmRejectionId).click(function () {
            if ($('#' + newBoxRejectionId + '>textarea').val() != "") {
                // deve chamar a funcao onClick original
                oldOnClick();
            } else {
                cryo_alert('O campo "' + strMessage + '" � de preenchimento obrigat�rio.');
                return false;
            }
        });
    }
}

function cryo_HideField(fieldXname) {
    // esconde um campo do formulario e
    // evita que ele seja validado como obrigatorio
    cryo_ControlField(fieldXname, "none");
}

function cryo_ShowField(fieldXname) {
    // mostra um campo do formul�rio
    cryo_ControlField(fieldXname, "");
}

function cryo_FadeField(fieldXName) {
    if (fieldXName && document.getElementById("td0" + fieldXName) && document.getElementById("td0" + fieldXName).style.display == "none") {
        NLBfadeBg("td0" + fieldXName, '#FFFF99', '#FFFFFF', '8000');
        NLBfadeBg("td1" + fieldXName, '#FFFF99', '#FFFFFF', '8000');
    } else if (document.getElementById(fieldXName)) {
        NLBfadeBg(fieldXName, '#FFFF99', '#FFFFFF', '8000');
    }
}

function cryo_ControlField(fieldXname, showOrHide) {
    var CONST_INT_CAMPO_UNICO = 1;
    // busca referencia ao campo
    var field = cryo_GetElementByXname("inp" + fieldXname);

    var fieldLength = CONST_INT_CAMPO_UNICO;
    if (field && field.length && typeof (field.type) == "undefined") {
        // � array de campos
        fieldLength = field.length;
    }

    // verifica se os objetos existem no formulario
    if (field) {
        var td0 = document.getElementById("td0" + fieldXname);
        var td1 = document.getElementById("td1" + fieldXname);

        if (td0) td0.style.display = showOrHide;
        if (td1) td1.style.display = showOrHide;

        if (fieldLength == CONST_INT_CAMPO_UNICO) {
            // � necess�rio esconder o campo caso ele n�o esteja dentro da estrutura padr�o do formulario
            field.style.display = showOrHide;
            if (showOrHide == "none") {
                // deixar o campo n�o-obrigat�rio e salvar a obrigatoriedade original
                var required = cryo_GetObjectPropertyValue(field, "required");
                cryo_SetObjectPropertyValue(field, "xrequired", required);
                cryo_SetObjectPropertyValue(field, "required", "");
                field.value = "";
            } else if (showOrHide == "block" || showOrHide == "") {
                // voltar a obrigatoriedade original do campo
                var required = cryo_GetObjectPropertyValue(field, "required");
                //isso evita que ao chamar showfield direto em um campo obrigatorio ele fique opcional.

                if (required == "") {
                    var xrequired = cryo_GetObjectPropertyValue(field, "xrequired");
                    cryo_SetObjectPropertyValue(field, "xrequired", "");
                    cryo_SetObjectPropertyValue(field, "required", xrequired);
                }
            }
        } else {
            for (i = 0; i < fieldLength; i++) {
                if (showOrHide == "none") {
                    // deixar o campo n�o-obrigat�rio e salvar a obrigatoriedade original
                    var required = cryo_GetObjectPropertyValue(field[i], "required");
                    cryo_SetObjectPropertyValue(field[i], "xrequired", required);
                    cryo_SetObjectPropertyValue(field[i], "required", "");
                    if (field[i].type.toUpperCase() == "CHECKBOX" || field[i].type.toUpperCase() == "RADIO") {
                        field[i].checked = false;
                    } else {
                        field[i].value = "";
                    }
                } else if (showOrHide == "block" || showOrHide == "") {
                    // voltar a obrigatoriedade original do campo
                    var required = cryo_GetObjectPropertyValue(field[i], "xrequired");
                    cryo_SetObjectPropertyValue(field[i], "xrequired", "");
                    cryo_SetObjectPropertyValue(field[i], "required", required);
                }
                // � necess�rio esconder o campo caso ele n�o esteja dentro da estrutura padr�o do formulario
                field[i].style.display = showOrHide;
            }
        }
    }
}

function cryo_ClearCombo(combo) {
    if (typeof (combo) != "object")
        combo = cryo_GetElementByXname("inp" + combo);

    if (combo.options) {
        for (i = combo.options.length - 1; i >= 0; i--) {
            if (combo.options[i].value != "")
                combo.options[i] = null;
        }
    } else if (combo.tagName && combo.type && combo.value) {
        if (combo.tagName == "input" && combo.type == "text") {
            combo.value = "";
        }
    }
}